import { gql } from "@apollo/client";

export default gql`
  mutation deleteUser($data: DeleteUserInput!){
    deleteUser(data: $data){
        success
        data{
            _id
            name
            surname
            role
            phone
            email
            createdAt
        }
        code
        message
    }
}
`
